import React, { ReactNode } from "react";

interface NetworkCardContainerProps {
  title: string;
  borderGradient?: string;
  children?: ReactNode;
}

const NetworkCardContainer: React.FC<NetworkCardContainerProps> = ({
  title,
  borderGradient = "linear-gradient(90deg, #6E7079 0%, rgba(53, 75, 153, 0) 100%)",
  children,
}) => {
  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "5px",
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
      }}
    >
      <div
        style={{
          display: "inline-block",
          borderBottom: "1px solid transparent",
          borderImageSource: borderGradient,
          borderImageSlice: 1,
          paddingBottom: "2px",
        }}
      >
        <span
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "10px",
            color: "rgba(110, 112, 121, 1)",
          }}
        >
          {title}
        </span>
      </div>

      {children}
    </div>
  );
};

export default NetworkCardContainer;